class GiveCodeForm {
    constructor(formElement) {
        this.formElement = formElement;
        this.setupElements();
        this.setupListeners();
        this.formConfig = this.getFormConfigs();
    }

    setupElements() {
        this.giveCodeInput = this.getGiveCodeInput();
        this.radioElements = this.getRadioElement();
        this.submitElement = this.getSubmitElement();
        this.errorElement = this.getErrorElement();
        this.postSubmissionModal = this.getModal();
        this.loginForm = this.getLoginForm();
        this.customerRegistrationForm = this.getCustomerRegistrationForm();
    }

    getLoginForm() {
        return this.postSubmissionModal.querySelector('.give-code-modal__form--sign-in form') || false;
    }

    getCustomerRegistrationForm() {
        return this.postSubmissionModal.querySelector('.give-code-modal__form--register form') || false;
    }

    setupListeners() {
        this.submitListener();
        this.formFocusListener();
    }

    getModal() {
        let modalId = this.formElement.dataset.modalId
        return document.getElementById(modalId)
    }

    getErrorElement() {
        return this.formElement.querySelector(".error")
    }

    getGiveCodeInput() {
        return this.formElement.querySelector(".give-code-registration__value");
    }

    getRadioElement() {
        return this.formElement.querySelector(
            ".give-code-registration__radios"
        );
    }

    getSubmitElement() {
        return this.formElement.querySelector('input[type="submit"]')
    }

    submitListener() {
        this.formElement.addEventListener("submit", async (e) => {
            e.preventDefault();
            try {
                this.giveCode = this.giveCodeInput.value;
                this.redirectUrl = this.getRedirectUrlFromFormValue();
                await this.assembleFormData();

                this.giveIdData = await this.postGivecodeData();

                if(this.redirectUrl) {
                    location.href = this.redirectUrl
                    return
                }

                this.updateRegisrationForms();
                this.postSubmissionModal.show()
            } catch(e) {
                console.log(e);
                this.submitElement.removeAttribute('disabled')
                this.errorElement.classList.remove('hidden')
                this.formElement.classList.remove("has-focused");
            }
        });
    }

    updateRegisrationForms() {
        if (this.loginForm && this.customerRegistrationForm) {
            let loginRedirectField = this.loginForm.querySelector('.post-action-return')
            let loginRedirectUrl = loginRedirectField.dataset.urlPrefix + this.giveIdData._id
            loginRedirectField.value = loginRedirectUrl

            localStorage.setItem('registrationRedirectUrl', loginRedirectUrl)
        }
    }

    async assembleFormData() {
        this.ipInfo = await this.getIpInfo();
        this.formValues = this.getFormValues();

        for (const key of Object.keys(this.ipInfo)) {
            if (!this.formConfig.neededIpInfo.includes(key)) continue;

            this.formValues[key] = this.ipInfo[key];
        }
    }

    async postGivecodeData() {
        return await fetch(this.formConfig.formDestination, {
            method: "POST",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.formValues),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((e) => {
                throw new Error(e)
            });
    }

    getFormValues() {
        const formData = new FormData(this.formElement);

        let formValues = {};
        for (const [key, value] of formData.entries()) {
            formValues[key] = value;
        }

        return formValues;
    }

    async getIpInfo() {
        return await fetch("https://ipapi.co/json")
            .then((response) => response.json())
            .then((data) => {
                return data;
            })
            .catch((e) => {
                throw new Error(e)
            });
    }

    getRedirectUrlFromFormValue() {
        try {
            if (
                typeof this.formConfig.suffixRedirects == "undefined" ||
                this.formConfig.suffixRedirects.length === 0 ||
                this.formConfig.suffixRedirects === false
            ) {
                throw new Error("No redirects were found.");
            }

            for (const redirect of this.formConfig.suffixRedirects) {
                if (this.giveCode.toLowerCase().endsWith(redirect.suffix.toLowerCase()))
                    return redirect.redirectUrl;
            }
        } catch (e) {
            console.log("An error occurred while processing redirects. " + e);
        }
    }

    formFocusListener() {
        this.giveCodeInput.addEventListener("focus", (e) => {
            this.formElement.classList.add("has-focused");
            this.errorElement.classList.add('hidden')
        });
    }

    getFormConfigs() {
        try {
            const formSettingsContent = document.getElementById(
                this.formElement.dataset.settingsId
            ).textContent;

            return JSON.parse(formSettingsContent);
        } catch (e) {
            console.log("Error parsing form settings data ");
            console.log(e);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const registrationForms = document.querySelectorAll(
        ".give-code-registration__form"
    );

    for (const registrationForm of registrationForms) {
        new GiveCodeForm(registrationForm);
    }
});
